import styled, { css } from 'styled-components';
import { colorSchemePreserveAttrs } from 'src/utils/colorScheme';

export const OnboardingLanguageFlag = styled.img.attrs(colorSchemePreserveAttrs)(
  ({ theme }) => css`
    width: ${theme.sz.s14};
    height: ${theme.sz.s14};
    border-radius: ${theme.bo.round};
    background: ${theme.co.neutral60};
  `,
);
